import React from 'react';

const DeviceTest = ({ testName, testInfo, onChange }) => {
  return (
    <div className="p-4 border rounded-md shadow-sm">
      <h3 className="text-lg font-semibold mb-2">{testName}</h3>
      <div className="mb-2">
        <label className="block text-gray-700">Last</label>
        <input
          type="text"
          value={testInfo.last}
          readOnly
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-gray-100"
        />
      </div>
      <div className="mb-2">
        <label className="block text-gray-700">Next</label>
        <input
          type="text"
          value={testInfo.next}
          readOnly
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-gray-100"
        />
      </div>
      <div className="mb-2">
        <label className="block text-gray-700">Performed By</label>
        <input
          type="text"
          value={testInfo.performedBy}
          onChange={(e) => onChange(e.target.value, 'performedBy')}
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
        />
      </div>
      <div className="mb-2">
        <label className="block text-gray-700">Witness</label>
        <input
          type="text"
          value={testInfo.witness}
          onChange={(e) => onChange(e.target.value, 'witness')}
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
        />
      </div>
      <div className="mb-2">
        <label className="block text-gray-700">Hours</label>
        <input
          type="text"
          value={testInfo.hours}
          onChange={(e) => onChange(e.target.value, 'hours')}
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
        />
      </div>
    </div>
  );
};

export default DeviceTest;
